import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { EmojiEvents } from '@material-ui/icons';
import { TeamColors } from 'utilities/team_colors';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    textAlign: 'center',
    fontSize: '1.9rem',
    fontWeight: 800,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  trophy: {
    fontSize: '1.9rem',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
    marginTop: -6,
    color: '#f9d976',
  },
}));

/** "Team 1 Wins" across the top of a finished game, in the winning team's color. */
export const WinnerBanner: React.FC<{team: number}> = ({team}) => {
  const classes = useStyles();
  const color = TeamColors[team];
  return (
    <div className={classes.root} style={{color, background: `linear-gradient(90deg, transparent, ${color}26, transparent)`, border: `1px solid ${color}55`}}>
      <EmojiEvents className={classes.trophy} />Team {team + 1} Wins
    </div>
  );
}
